import { useRef, useEffect } from 'react'

export function useAutoScroll(deps: unknown[]) {
  const ref = useRef<HTMLDivElement>(null)
  const hasScrolled = useRef(false)

  useEffect(() => {
    if (!hasScrolled.current) {
      ref.current?.scrollIntoView()
      if (deps[0] && (deps[0] as unknown[]).length > 0) hasScrolled.current = true
    } else {
      ref.current?.scrollIntoView({ behavior: 'smooth' })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return ref
}
